export default "__VITE_ASSET__4t7W6WcG__"